$(document).ready(function () {
  $(".menu-btn").click(function () {
    $(".mobile-menu").toggleClass("wrap-menu");
    setTimeout(function () {
      $(".mobile-menu").toggleClass("mobile-menu-hide");
    }, 200);
  });
  $(".mobile-menu .menu-item").click(function () {
    $(".mobile-menu").toggleClass("wrap-menu");
    $(".mobile-menu").toggleClass("mobile-menu-hide");
  });
});



// WEBPACK FOOTER //
// ./scripts/libraries/common.js